class OncePress {
 constructor() {
     this.pressTimers = {}; // 存储每个事件的计时器
 }

 onPress(eventName, callback) {
     if (!this.pressTimers[eventName]) {
         this.pressTimers[eventName] = setTimeout(() => {
             delete this.pressTimers[eventName]; // 清除计时器
         }, 2000); // 设置3秒的间隔时间
         callback(); // 调用回调函数
     }
 }
}

export default OncePress;
// fnN为立刻执行函数，fn为节流函数
export function throttle(fnN,fn, delay, isFirstThrottle = true) {
    let last = 0;
    let timer = null;
    return function () {
      let context = this;
      let args = arguments;
      let flag = fnN.apply(context, args);
      if (isFirstThrottle) {
        let now = Date.now();
        if (now - last > delay) {
          if(flag){
            fn.apply(context, args);
            last = now;
          }
        }
      } else {
        if (!timer) {
          timer = setTimeout(function () {
            if(flag){
              fn.apply(context, args);
              last = now;
            }
            timer = null;
          }, delay);
        }
      }
    }
   }


// WEBPACK FOOTER //
// ./src/directives/limit.js